import { Helmet } from 'react-helmet-async';

const NotFound = () => (
  <>
    <Helmet>
      <title>Pagina niet gevonden - Timmers BV</title>
      <meta name="description" content="Deze pagina bestaat niet of is niet meer beschikbaar." />
      <meta name="robots" content="noindex, follow" />
    </Helmet>
    <main id="maincontent" className="page-main" style={{ marginTop: '30px', minHeight: '50vh' }}>
      <div className="row-full-width-inner">
        <h1>Pagina niet gevonden</h1>
        <p>De pagina die u zoekt bestaat niet of is verplaatst.</p>
        <p><a href="/webshop">Ga naar de webshop</a> of <a href="/contact">neem contact op</a>.</p>
      </div>
    </main>
  </>
);

export default NotFound;
